// Partner attribution: a BDM's share links carry ?p=CODE. We stash it so the
// tag survives navigation (landing page -> apply page -> handoff) and attach it
// to the apply-intent capture, which mints the GRC reference code.
const KEY = "grc_partner_code";
const CAMPAIGN_KEY = "grc_campaign";

export function capturePartnerCode() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = (params.get("p") || "").trim().toUpperCase();
    if (code && /^[A-Z0-9]{3,12}$/.test(code)) sessionStorage.setItem(KEY, code);
    const campaign = (params.get("utm_campaign") || params.get("c") || "").trim();
    if (campaign) sessionStorage.setItem(CAMPAIGN_KEY, campaign.slice(0, 80));
  } catch (e) {
    /* private mode — attribution just falls back to untagged */
  }
}

export function getPartnerCode() {
  try {
    return sessionStorage.getItem(KEY) || "";
  } catch (e) {
    return "";
  }
}

export function getCampaign() {
  try {
    return sessionStorage.getItem(CAMPAIGN_KEY) || "";
  } catch (e) {
    return "";
  }
}

// Campaign pages own their tag, so a visitor who arrives without ?c= is still
// attributed to the campaign they actually landed on.
export function setCampaign(name) {
  try {
    if (name) sessionStorage.setItem(CAMPAIGN_KEY, String(name).slice(0, 80));
  } catch (e) {
    /* private mode — attribution just falls back to untagged */
  }
}
